import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import { tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';

const imageDimension = 'min(40vw, 60vh)';
const imageDimensionMobile = '70vw';
export const imageInfoStyles = {
	contentWrapper: {
		backgroundColor: 'colors.dark6',
		overflow: { xs: 'auto', [tabletBreakpoint]: 'hidden' },
		maxWidth: '100%',
		maxHeight: '100%',
	},
	confirmScreenWrapper: {
		width: 'calc(100vw - 64px)',
		maxWidth: '970px',
		height: { xs: '100%', [tabletBreakpoint]: 'fit-content' },
		display: 'flex',
		flexDirection: 'column',
	},
	confirmScreenContent: {
		flexGrow: 1,
		height: { xs: '100%', [tabletBreakpoint]: '80vh' },
		maxHeight: { xs: 'unset', [tabletBreakpoint]: '711px' },
		display: 'flex',
		flexDirection: { xs: 'column-reverse', [tabletBreakpoint]: 'row' },
		alignItems: 'stretch',
		overflow: 'auto',
	},
	confirmScreenPromptDetailsCont: {
		width: { xs: '100%', [tabletBreakpoint]: '50%' },
		display: 'flex',
		flexDirection: 'column',
	},
	confirmScreenPromptDetails: {
		padding: { xs: '24px', [tabletBreakpoint]: '24px 10px 24px 24px' },
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},
	modelDetail: {
		padding: '4px 8px',
		borderRadius: '16px',
		border: `1px solid ${colorPalette.dark1}`,
		backgroundColor: 'colors.dark3',
		display: 'flex',
		alignItems: 'center',
		gap: '4px',
	},
	modelImage: {
		width: '24px',
		height: '24px',
		borderRadius: '50%',
		overflow: 'hidden',
		'& img': {
			height: '100%',
			width: '100%',
			objectFit: 'cover',
		},
	},
	buttonStyles: {
		padding: '8px 16px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: '4px',
		cursor: 'pointer',
	},
	divider: {
		width: '100%',
		borderBottom: `1px solid ${colorPalette.dark3}`,
	},
	confirmScreenButtonsCont: {
		padding: '8px 24px 24px',
		display: 'flex',
		flexDirection: { md: 'column', xl: 'row' },
		justifyContent: 'center',
		gap: '16px',
	},
	publishPromptButton: {
		width: '100%',
		color: 'colors.dark6',
		backgroundColor: 'colors.light1',
		'&:hover': { backgroundColor: 'colors.light1' },
		'&.Mui-disabled': {
			color: 'colors.light5',
			backgroundColor: 'colors.dark2',
		},
	},
	confirmScreenImgWrapper: {
		flexShrink: 0,
		width: { xs: '100%', [tabletBreakpoint]: '50%' },
		maxWidth: { xs: 'unset', [tabletBreakpoint]: '520px' },
		height: { xs: imageDimensionMobile, [tabletBreakpoint]: '100%' },
		maxHeight: { xs: '50vh', [tabletBreakpoint]: 'unset' },
		padding: '0 58px',

		display: 'flex',
		alignItems: 'center',
	},
	confirmScreenImgCont: {
		width: '100%',
		height: '100%',

		position: 'relative',
	},
	image: {
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,

		paddingBottom: { xs: '16px', [tabletBreakpoint]: 0 },

		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',

		overflow: 'hidden',

		'& img': {
			height: '100%',
			width: '100%',
			objectFit: 'contain',
		},
	},
	detailScreenImgCont: {
		width: '100%',
		paddingTop: '100%',

		position: 'relative',
	},
	detailScreenContent: {
		display: 'flex',
		alignItems: 'stretch',
	},
	detailScreenImgWrapper: {
		flexShrink: 0,
		width: { xs: imageDimensionMobile, [tabletBreakpoint]: imageDimension },
		height: { xs: imageDimensionMobile, [tabletBreakpoint]: imageDimension },
	},

	promptDetailsScrollWrapper: {
		flexGrow: 1,
		overflow: { xs: 'auto', [tabletBreakpoint]: 'scroll' },
	},
	promptDetailsCont: {
		width: { xs: '100%', [tabletBreakpoint]: imageDimension },
		height: { xs: 'fit-content', [tabletBreakpoint]: imageDimension },
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
	},
	detailScreenPromptDetails: {
		padding: { xs: '16px 8px', [tabletBreakpoint]: '0 16px 24px 16px' },
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},
	detailCard: {
		width: '100%',
		padding: '12px',
		borderRadius: '4px',
		backgroundColor: 'colors.dark5',
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},
	detailCardModelImage: {
		height: '24px',
		width: '24px',
		borderRadius: '50%',
		overflow: 'hidden',
		'& img': { height: '100%', width: '100%', objectFit: 'cover' },
	},
	copyDetailButton: {
		display: 'flex',
		cursor: 'pointer',
		'& svg': {
			height: '16px',
			width: 'auto',
		},
	},
	detailValue: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		gap: '4px',
		'& svg': { fill: colorPalette.light5, height: '20px', width: '20px' },
	},
	basicDetailsCont: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
	},
	detailScreenButtonsCont: {
		padding: '24px 16px',
		borderTop: `1px solid ${colorPalette.dark4}`,

		backgroundColor: 'colors.dark5',

		display: 'flex',
		flexDirection: {
			xs: 'column',
			sm: 'row',
			md: 'column',
			xxl: 'row',
		},
		justifyContent: 'center',
		gap: '16px',
	},
	actionButtonStyles: {
		padding: '10px 10px',
		borderRadius: '4px',

		textTransform: 'none',

		display: 'flex',
		alignItems: 'center',
		gap: '4px',

		'& svg': { height: '24px', width: 'auto' },
	},
	downloadButton: {
		flexGrow: 1,
		minWidth: 'unset',
		backgroundColor: 'colors.dark3',

		'&:hover': { backgroundColor: 'colors.dark3' },
	},
};
